import _mixin from '../_mixin'

export default {
  name: 'STopic2KV',
  cnName: 'KV头图',
  type: 'activity_topic2',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/10/11/1a2010609b022af266bccfafaa1d88fa.jpg',
      style: {
        width: '1920px',
        height: '1000px'
      }
    },
    logoImg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/10/11/244874465c179a2bb01610a7455515f5.png',
      style: {
        width: '285px',
        height: '50px',
        top: '27px',
        right: '',
        bottom: '',
        left: '43px'
      }
    },
    btnReturn: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/10/11/df1c02fa201939acd1e557b4ceb46196.png',
      style: {
        width: '189px',
        height: '53px',
        top: '27px',
        right: '74px',
        bottom: '',
        left: ''
      }
    },
    btnReturnLink: 'https://www.ssjj.cn/',
    btnDownLoad: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/10/11/ecfb9b04955bf6f136f3e0f733a1d7e1.png',
      style: {
        width: '277px',
        height: '80px',
        top: '',
        right: '821px',
        bottom: '350px',
        left: ''
      }
    },
    pointMark: 'xxxDownload',
    giftImg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/06/06/0bf0285b9ea6cb63f00c85f2caa37352.png',
      style: {
        width: '500px',
        height: '200px',
        top: '',
        right: '710px',
        bottom: '90px',
        left: ''
      }
    }
  },
  propsDesc: [
    {
      target: 'defaultBg',
      label: 'kv图',
      formType: 'image'
    },
    /* logo配置 */
    {
      target: 'logoImg',
      label: 'logo图片',
      formType: 'image'
    },
    /* 返回按钮配置 */
    {
      target: 'btnReturn',
      label: '返回按钮图片',
      formType: 'image'
    },
    {
      target: 'btnReturnLink',
      label: '返回按钮转链'
    },
    /* 下载按钮配置 */
    {
      target: 'btnDownLoad',
      label: '下载按钮图片',
      formType: 'image'
    },
    {
      target: 'pointMark',
      label: '埋点标识'
    },
    /* 礼包图配置 */
    {
      target: 'giftImg',
      label: '礼包图片',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
